import AiCard from '@/pages/Web/PageComponents/CaseSimulation/AiCard';
import MobileAiCard from '@/pages/Mobile/PageComponents/CaseSimulation/AiCard';
import { Display } from '@/components/Display/Display';
const CaseSimulation = (props) => {
    const { side = 'web', ...otherProps } = props;
    return (
        <>
            <Display show={side === 'web'}>
                <AiCard side={side} {...otherProps}></AiCard>
            </Display>
            <Display show={side === 'mobile'}>
                <MobileAiCard side={side} {...otherProps}></MobileAiCard>
            </Display>
        </>
    );
};
export default CaseSimulation;
